// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

export const formField = css`
    display: flex;
    flex-direction: column;
    flex: 1;

    label span {
        display: none;
    }
`;
